import styled from 'styled-components';
import { ReactComponent as UserAgentIcon } from 'Images/automation.svg';
import { ellipsisText } from 'Styles/styles';

export const Wrapper = styled.div`
`;
Wrapper.displayName = 'Wrapper';

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  & >:last-child {
    margin-left: 15px
  }
`;
Top.displayName = 'Top';

export const AgentIcon = styled(UserAgentIcon)`
  cursor: default;
  g, path {
    fill: ${({ theme }) => theme.text.tab};
  }
`;
AgentIcon.displayName = 'AgentIcon';

export const Name = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.tab};
  max-width: 320px;
  ${ellipsisText};
  margin: 0 16px;
`;
Name.displayName = 'Name';

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: auto;
`;
Left.displayName = 'Left';

export const Right = styled.div`
  display: flex;
  margin-left: auto;
`;
Right.displayName = 'Right';

export const Description = styled.div`
  padding: 16px 21px 0 40px;
  font-size: 11.5px;
  font-weight: normal;
  line-height: 1.48;
  color: ${({ theme }) => theme.text.modalDescription};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`;
Description.displayName = 'Description';
